import React from "react";
import "./style.scss";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="container-fluid nav-footer d-flex justify-content-center align-items-center flex-wrap">
      <a
        href={"http://www.sherwin-williams.com/"}
        className="nav-footer-item"
        target="_blank"
        rel="noopener noreferrer"
      >
        www.sherwin-williams.com
      </a>
      <a
        href="http://privacy.sherwin-williams.com/"
        className="nav-footer-item"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Statement
      </a>
      <a
        href="http://www.sherwin-williams.com/terms/"
        className="nav-footer-item"
        target="_blank"
        rel="noopener noreferrer"
      >
        Legal Notice
      </a>
      <div className="nav-footer-release_item">&copy;{currentYear} The Sherwin Williams Company</div>
      <div className="nav-footer-release_item br-none justify-content-end">Release: {window.VERSION}</div>
    </footer>
  );
};
export default Footer;
